import { jwtDecode } from 'jwt-decode';

export type UserRole =
  | 'admin'
  | 'staff'
  | 'manager'
  | 'support'
  | 'operation'
  | 'account'
  | 'packer'
  | 'rider'
  | 'customer'
  | 'vendor'
  | 'tagger'
  | 'guard'
  | 'audit'
  | 'agency'
  | 'driver';

export interface AccessClaims {
  id: number;
  name?: string;
  username?: string;
  phone_number?: string;
  role: UserRole;
  /** From Django `User.is_superuser`; grants full BI access regardless of `role`. */
  is_superuser?: boolean;
  related_stores?: number[];
  exp: number;
  iat?: number;
}

/** Roles permitted to use Fasto BI (mirrors the backend permission). */
export const BI_ALLOWED_ROLES: ReadonlySet<UserRole> = new Set([
  'admin',
  'staff',
  'manager',
  'support',
  'operation',
  'account',
]);

export function decodeAccess(token: string): AccessClaims | null {
  try {
    return jwtDecode<AccessClaims>(token);
  } catch {
    return null;
  }
}

export function isExpired(claims: AccessClaims | null, skewSeconds = 30): boolean {
  if (!claims) return true;
  return Date.now() / 1000 >= claims.exp - skewSeconds;
}

export function canUseBI(role: UserRole | undefined | null, isSuperuser?: boolean | null): boolean {
  if (isSuperuser) return true;
  if (!role) return false;
  return BI_ALLOWED_ROLES.has(role);
}
